<template>
  <div class="button-container">
    <span class="button-title">{{ title }}</span>
    <img src="../../assets/images/arrow.png" class="image" alt="">
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  @include flex;
  padding: 14px 24px;
  background: $base-color;
  border-radius: 60px;
  width: fit-content;
  margin-top: 40px;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    padding: 13px 22px;
    width: 100%;
    justify-content: space-between;
    border-radius: 50px;
    margin-top: 30px;
  }

  .button-title {
    color: #000000;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    @media only screen and (max-width: 767px) {
      font-size: 15px;
    }
  }

  .image {
    margin-left: 10px;
  }

}
</style>